<script>
import { asyncAngularInvoke } from "/vodalys/vvuejs";
export default {
  translate25Context: ["vrun_form", "project.access.form"],
  components: {  },
  props: ["component", "handler"],
  data: function () {
    return {
      addpanel: {
        open: false,
      },
      selectedLanguageId: null,
      selectedPreviewUrl: null,
      pending: false,
    };
  },
  methods: {
    addLanguage: function () {
      var _zis = this;
      asyncAngularInvoke(function ($rootScope, $rootElement, v17Modal) {
        v17Modal.input($rootScope, $rootElement.find("body"), {
          title: _zis.$vt("Add language"),
          okLabel: _zis.$vt("Add"),
          ok: function (input) {
            return _zis.handler.action(_zis.component, "add_language", [input]);
          },
        });
      });
    },
    editLanguage: function (language) {
      var _zis = this;
      asyncAngularInvoke(function ($rootScope, $rootElement, v17Modal) {
        v17Modal.input($rootScope, $rootElement.find("body"), {
          title: _zis.$vt("Edit language"),
          placeholder: language.language,
          okLabel: _zis.$vt("Edit"),
          ok: function (input) {
            return _zis.handler.action(language, "edit", [input]);
          },
        });
      });
    },
    deleteField: function (field) {
      var _zis = this;
      asyncAngularInvoke(function ($rootScope, $rootElement, v17Modal) {
        v17Modal.yesNo($rootScope, $rootElement.find("body"), {
          title: _zis.$vt("Delete field"),
          message: _zis.$vt("Are you sure you want to delete") + " " + field.title + "?",
          yesLabel: _zis.$vt("Delete"),
          yesType: "negative",
          yes: function (input) {
            return _zis.handler.action(field, "delete");
          },
        });
      });
    },
    deleteLanguage: function (language) {
      var _zis = this;
      asyncAngularInvoke(function ($rootScope, $rootElement, v17Modal) {
        v17Modal.yesNo($rootScope, $rootElement.find("body"), {
          title: _zis.$vt("Delete language"),
          message: _zis.$vt("Are you sure you want to delete") + " " + language.language + "?",
          yesLabel: _zis.$vt("Delete"),
          yesType: "negative",
          yes: function (input) {
            return _zis.handler.action(language, "delete").then(function () {
              _zis.selectedLanguageId = Object.values(
                _zis.component.languages
              )[0].id;
            });
          },
        });
      });
    },
    createField: function (field) {
      this.pending = true;
      this.handler.action(field, "create").then(
        () => {
          this.pending = false;
          this.addpanel.open = false;
        },
        () => {
          this.pending = false;
          this.addpanel.open = false;
        }
      );
    },
    ondrop: function (args) {
      var SortedFields = Object.values(this.component.fields).sort(function (
        l1,
        l2
      ) {
        return parseInt(l1.weight) - parseInt(l2.weight);
      });

      var t = SortedFields.splice(args.removedIndex, 1);

      SortedFields.splice(args.addedIndex, 0, ...t);

      for (var i in SortedFields) {
        SortedFields[i].weight = i;
      }

      this.handler.action(this.component, "set_weights", [
        SortedFields.map((l) => {
          return l.nid;
        }),
      ]);
    },
  },
  created() {},
  computed: {},
  mounted() {
    this.selectedLanguageId = Object.values(this.component.languages)[0].id;
  },
  watch: {
    selectedLanguageId(newId, oldId) {
      var url = new URL(this.component.preview_url);

      url.searchParams.set("force_language", newId);

      this.selectedPreviewUrl = url.href;
    },
  },
};
</script>
    
<template>
  <div class="vrun-form-builder">
    <div class="f-left">
      <div class="vrun-form-builder-languages">
        <f-mini-tab
          @select="selectedLanguageId = language.id"
          :label="language.language"
          :selected="selectedLanguageId == language.id"
          v-for="language in component.languages"
          :key="language['#id']"
        >
          <div class="vrun-form-builder-language-label">
            {{ language.language }}
          </div>
          <template #action>
            <f-button type="icon small tertiary" @click="editLanguage(language)"
              ><f-icon icon="fa6-pen-clip"></f-icon
            ></f-button>
            <f-button
              v-if="!language.undeletable"
              type="icon small tertiary"
              @click="deleteLanguage(language)"
              ><f-icon icon="fa6-xmark"></f-icon
            ></f-button>
          </template>
        </f-mini-tab>
        <f-mini-tab
          v-if="
            Object.keys(component.languages).length < component.max_languages
          "
          @select="addLanguage()"
          icon="fa6-plus"
          :label="$vt('Add language')"
        ></f-mini-tab>
      </div>
      <iframe :src="selectedPreviewUrl"></iframe>
    </div>
    <div class="f-right">
      <f-form sticky-action scroll>
        <template #title> <f-icon icon="fa6-gears"></f-icon>{{ $vt("Settings") }} </template>
        <template #content>
          <div class="vrun-form-builder-content">
            <vue-angular-place-holder
              :component="component.form"
              :handler="handler"
            >
            </vue-angular-place-holder>
            <!-- <vue-placeholder
              :component="component.title"
              :handler="handler"
            ></vue-placeholder>
            <vue-placeholder
              :component="component.button"
              :handler="handler"
            ></vue-placeholder> -->
            <div class="vrun-form-builder-items">
              <f-form scroll>
                <template #title>{{ $vt("Fields") }}</template>
                <template #content>
                  <Container @drop="ondrop($event)" lock-axis="y">
                    <Draggable
                      :key="field['#id']"
                      v-for="field in $options.filters.angularFilter(
                        component.fields,
                        ['weight'],
                        'orderObjectBy'
                      )"
                    >
                      <f-list-item
                        variant="default"
                        class="vrun-form-builder-item"
                        @click="handler.action(field, 'select')"
                        :icon="field.icon"
                      >
                        <div>
                          {{ field.title }}
                        </div>
                        <div class="vrun-form-builder-item-actions">
                          <f-button
                            class="delete"
                            type="icon small transparent"
                            @click.stop="deleteField(field)"
                          >
                            <f-icon icon="fa6-trash-can"></f-icon>
                          </f-button>
                        </div>
                      </f-list-item>
                    </Draggable>
                  </Container>
                </template>
              </f-form>
            </div>
          </div>
        </template>
        <template #action>
          <f-button type="primary" @click="addpanel.open = true">
            <f-icon icon="fa6-plus"></f-icon>{{ $vt("Add field") }}
          </f-button>
        </template>
      </f-form>

      <div
        class="vrun-form-builder-item-form"
        :class="{ open: component.selected_field_form != null }"
      >
        <f-form sticky-action scroll>
          <template #title v-if="component.selected_field_form">
            <f-icon :icon="component.selected_field_form.icon"></f-icon>
            {{ component.selected_field_form.title }}
          </template>
          <template #content>
            <div v-if="component.selected_field_form">
              <vue-angular-place-holder
                :component="component.selected_field_form.form"
                :handler="handler"
              >
              </vue-angular-place-holder>
            </div>
          </template>
          <template #action>
            <f-button
              type="secondary"
              @click="handler.action(component, 'close_item_form')"
            >
              <f-icon icon="fa6-angle-left"></f-icon>{{ $vt("Back") }}
            </f-button>
          </template>
        </f-form>
      </div>

      <div class="vrun-form-builder-additem" :class="{ open: addpanel.open }">
        <f-form sticky-action :pending="pending">
          <template #title>
            <f-icon icon="fa6-plus"></f-icon>{{ $vt("Add field") }}
          </template>
          <template #content>
            <div class="vrun-form-builder-additem-items">
              <f-list-item
                variant="default"
                :icon="field.icon"
                @click="createField(field)"
                v-for="field in $options.filters.angularFilter(
                  component.items_templates,
                  'weight',
                  'orderObjectBy'
                )"
                :key="field['#id']"
              >
                {{ field.title }}
              </f-list-item>
            </div>
          </template>
          <template #action>
            <f-button type="secondary" @click="addpanel.open = false">
              <f-icon icon="fa6-angle-left"></f-icon>{{ $vt("Back") }}
            </f-button>
          </template>
        </f-form>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.vrun-form-builder {
  display: flex;
  height: 100%;

  > .f-left {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    .vrun-form-builder-languages {
      display: flex;

      .vrun-form-builder-language-label {
        border-bottom: 1px dashed transparent;
      }

      .f-mini-tab {
        .f-action {
          opacity: 0;
        }

        &:hover .f-action,
        &.f-mini-tab-selected .f-action {
          opacity: 1;
        }
      }
    }

    iframe {
      flex: 1 1 auto;
      width: 100%;
      border: none;
    }
  }

  > .f-right {
    position: relative;
    flex: 0 0 458px;
    overflow: hidden;
    padding: 12px;
    box-sizing: content-box;

    > .f-form {
      height: 100%;
      background: var(--black);
      box-shadow: 0px 4px 16px rgba(22, 22, 21, 0.1);
      border-radius: 8px;

      > .title {
        padding: 12px;
      }

      > .content-container {
        > .f-sexy-scroll {
          display: flex;
          flex-direction: column;

          > .f-sexy-scroll-inner {
            height: 0;
            flex: 1 1 100%;

            > .content {
              height: 100%;
            }
          }
        }
        .sticky-action {
          margin: 8px 32px 32px 32px;
        }
      }

      .vrun-form-builder-content {
        flex: 1 1 100%;
        display: flex;
        flex-direction: column;
        gap: 16px;

        .vrun-form-builder-items {
          display: flex;
          flex-direction: column;
          height: 0;
          flex: 1 1 auto;
          min-height: 200px;

          .f-form {
            height: 100%;

            > .title {
              height: auto;
              padding: 0;
              color: var(--white-a75);
              text-transform: uppercase;
            }

            > .content-container {
              margin-top: 16px;
              border: 1px solid var(--white-a10);
              border-radius: 8px;
              padding: 8px;

              .content {
                padding: 0;
                margin: 0;

                .smooth-dnd-container {
                  display: flex;
                  flex-direction: column;
                  gap: 8px;
                }
              }
            }
          }

          .vrun-form-builder-item-title {
            display: flex;
            gap: 6px;
          }

          .vrun-form-builder-item-actions {
            display: flex;
            gap: 6px;
            margin-left: auto;

            button:hover {
              background-color: #1890d31a;
            }
          }
        }
      }
    }

    .vrun-form-builder-additem,
    .vrun-form-builder-item-form {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 100%;
      top: 0px;
      transition-property: left visibility;
      transition-duration: 0.5s;
      transition-timing-function: ease;
      visibility: hidden;
      padding: 12px;

      > .f-form {
        height: 100%;

        .vrun-form-builder-additem-items {
          flex: 1 1 100%;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
        }

        .sticky-action {
          margin: 20px;
        }
      }

      &.open {
        left: 0px;
        top: 0px;
        visibility: visible;
      }
    }
  }
}
</style>